<div class="modal__background" (click)="Close()"></div>
@if (open) {
  <div class="modal" @enterLeave [ngClass]="{'mobile': mobile}">
    <div class="modal__header">
      {{ "MEDIFINDER.NEW_SEARCH.TITLE" | translate }}
      <app-icon-button (action)="Close()" class="icon-button" src="icons/32/close.svg"></app-icon-button>
    </div>
    <div class="modal__content modal__content--{{creationState}}">
      @if (creationState === CreationState.INIT) {
        <div>
          <!-- drug selection -->
          <div class="drug-search">
            <label class="label-form">{{"MEDIFINDER.NEW_SEARCH.DRUG.LABEL" | translate}}</label>
            <div class="drug-search__search-and-result" [ngClass]="{'drug-selected': selectedDrug}">
              <div class="drug-search__search">
                <app-input-search-text (action)="onDrugInput($event)"
                  [placeholder]="'MEDIFINDER.NEW_SEARCH.DRUG.PLACEHOLDER' | translate"
                  [bottomEffectOnInput]="true"
                [icon]="SearchIcons.book"></app-input-search-text>
                @if (drugSearchInput && drugSearchInput.length > 0) {
                  <div class="drug-search__result"
                    >
                    @if (result && result.length) {
                      <div class="drug-search__result__inner"
                        [@listAnimation]="result.length">
                        @for (drug of result; track drug) {
                          <a href="#" class="drug-search__result__drug"
                            (click)="onSelectDrug($event, drug)">
                            {{drug.packagename}}
                            <app-svg-icon
                              class="icon"
                              [src]="'icons/24/arrow-right.svg'"
                              [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
                            ></app-svg-icon>
                          </a>
                        }
                      </div>
                    } @else {
                      @if (searchDrugModal) {
                        <app-loading></app-loading>
                      }
                      @if (!searchDrugModal && drugSearchInput.length > 2) {
                        <p
                        class="center no-results">{{"MEDIFINDER.NEW_SEARCH.DRUG.NO_RESULT" | translate}}</p>
                      }
                      @if (!searchDrugModal && drugSearchInput.length <= 2) {
                        <p
                        class="center no-results">{{"MEDIFINDER.NEW_SEARCH.DRUG.MORE_THAN_2" | translate}}</p>
                      }
                    }
                  </div>
                }
              </div>
              <div class="drug-search__selected-drug">
                @if (selectedDrug) {
                  <div class="box">
                    <p class="caption">{{selectedDrug.productname}}</p>
                    <p class="package">{{selectedDrug.packagename}}</p>
                    <app-svg-icon
                      class="icon"
                      [src]="'icons/24/close_circle.svg'"
                      [svgStyle]="{ 'width.px': '24', 'height.px': '24' }"
                      (click)="selectedDrug = undefined"
                    ></app-svg-icon>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="spacer spacer-6"></div>
          <!--pharmacy selection -->
          <div class="person-selection">
            <label class="caption">{{"MEDIFINDER.NEW_SEARCH.PERSON.LABEL" | translate}}</label>
            <p class="color--secondary bold">{{ (userDisplayName$ | async) }}</p>
            @if (pharmacies$ | async; as pharmacies) {
              @for (pharmacy of pharmacies; track trackBy($index, pharmacy); let last = $last) {
                <div class="pharmacy-box" [ngClass]="{'pharmacy-box--active': selectedPharmacy == pharmacy.id, 'pharmacy-box--single': pharmacies.length === 1}" (click)="selectedPharmacy = pharmacy.id">
                  <p>{{pharmacy.attributes.name}}</p>
                  <div class="pharmacy__link">
                    <app-svg-icon
                      class="icon"
                      [src]="'icons/32/phone.svg'"
                      [svgStyle]="{ 'width.px': '32', 'height.px': '32' }"
                    ></app-svg-icon>
                    <a id="pharmacy-phone" class="button-text"
                    href="tel:{{transformPhoneNumber(pharmacy.attributes.phone)}}">{{pharmacy.attributes.phone}}</a>
                  </div>
                  <div class="pharmacy__link">
                    <app-svg-icon
                      class="icon"
                      [src]="'icons/32/mail.svg'"
                      [svgStyle]="{ 'width.px': '32', 'height.px': '32' }"
                    ></app-svg-icon>
                    <a id="pharmacy-email" class="button-text"
                    href="mailto:{{pharmacy.attributes.email}}">{{pharmacy.attributes.email}}</a>
                  </div>
                  @if (last && !contentInit) {
                    {{ onContentInit(pharmacies) }}
                  }
                </div>
              }
            }
          </div>
          <div class="spacer spacer-10"></div>
        </div>
        <div>
          <app-button [fullWidth]="true" [label]="'MEDIFINDER.NEW_SEARCH.SUBMIT' | translate"
          (click)="createNewSearch()" [disabled]="!(selectedDrug && selectedPharmacy)"></app-button>
          <div class="spacer spacer-4"></div>
        </div>
      }
      @if (creationState === CreationState.LOADING) {
        <app-loading></app-loading>
      }
      @if (creationState === CreationState.SUCCESS) {
        <div class="flex-center">
          <app-svg-icon
            class="icon"
            [src]="'icons/124/circle-check.svg'"
            [svgStyle]="{ 'width.px': '124', 'height.px': '124' }"
          ></app-svg-icon>
          <div class="spacer-2"></div>
          <p>{{'MEDIFINDER.NEW_SEARCH.CREATION.SUCCESS' | translate}}</p>
        </div>
        <div>
          <div [innerHTML]="'MEDIFINDER.NEW_SEARCH.CREATION.INFO' | translate" class="info"></div>
          <div class="spacer spacer-6"></div>
          <app-button label="{{'MEDIFINDER.NEW_SEARCH.CREATION.CLOSE' | translate}}"
          (action)="Close()" [fullWidth]="true" [buttonType]="ButtonType.Secondary"></app-button>
          <div class="spacer-3"></div>
        </div>
      }
      @if (creationState === CreationState.ERROR) {
        <div class="flex-center">
          <div class="spacer-3"></div>
          <app-svg-icon
            class="icon"
            [src]="'icons/124/circle-error.svg'"
            [svgStyle]="{ 'width.px': '124', 'height.px': '124' }"
          ></app-svg-icon>
          <div class="spacer-3"></div>
          <p>{{'MEDIFINDER.NEW_SEARCH.CREATION.ERROR' | translate}}</p>
          <p class="caption">{{ errortext }}</p>
          <div class="spacer-3"></div>
          <app-button label="{{'MEDIFINDER.NEW_SEARCH.CREATION.CLOSE' | translate}}"
          (action)="Close()" [fullWidth]="true"></app-button>
        </div>
      }
    </div>
  </div>
}
